import cx from 'classnames';
import { useSelector } from 'react-redux';
import ErrorIcon from 'src/assets/images/icons/ErrorIcon';
import { RootState } from 'src/store';

export const LoginErrorMessage = () => {
  const globalError = useSelector((state: RootState) => state.auth.globalError);

  return (
    <div className={cx('errorMessage', { visible: globalError?.message })}>
      <ErrorIcon hideBackground fill="#E92C2C" />
      {globalError?.message}
      &nbsp;
    </div>
  );
};
